import React, { useState, useEffect } from "react";
import "@ant-design/compatible/assets/index.css";
import { Form, Button, Select, DatePicker, Checkbox, Row, Input } from "antd";
import { useDispatch } from "react-redux";
import * as actions from "../../store/actions/index";
import moment from "moment";

const { Option } = Select;

const ManualTriggerForm = (props) => {
  const { hmgData, projectData, hotelData } = props;

  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [hmgId, setHmgId] = useState(undefined);
  const [filteredHotels, setFilteredHotels] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [hotelId, setHotelId] = useState(undefined);
  const [validEnvelope, setValidEnvelope] = useState(undefined);

  const onFinish = async (values) => {
    let requestBody = {
      hmgId: values.hmg,
      hotelId: values.hotel,
      businessDate: values.businessDate.format("MM-DD-YYYY"),
      skipMandatory:
        values.skipMandatory === undefined ? false : values.skipMandatory,
    };

    let hotel = filteredHotels.filter((item) => {
      return item._id === hotelId;
    })[0];

    for (const project of filteredProjects) {
      if (
        hotel.primary_hmg_id === project._id ||
        hotel.secondary_hmg_id === project._id ||
        hotel.third_hmg_id === project._id ||
        hotel.fourth_hmg_id === project._id
      ) {
        requestBody.entityId = project.entityId;
        requestBody.projectId = project.projectId;
        requestBody.projId = project._id;

        break;
      }
    }

    console.log(requestBody);

    dispatch(actions.setSecondaryEnvelopeManualTrigger(requestBody));
  };

  const hmgChange = (hmgId) => {
    let filteredProjects = projectData
      .filter((item) => {
        return item.hmg_id === hmgId && item.solution === "PNA";
      })
      .map((item) => {
        return {
          entityId: item.is_entityid,
          projectId: item.project_id,
          _id: item._id,
        };
      });

    let filteredProjectIds = filteredProjects.map((item) => item._id);

    let filteredHotels = hotelData.filter((item) => {
      if (
        item.secondary_envelopes &&
        item.secondary_envelopes.length > 0 &&
        (filteredProjectIds.includes(item.primary_hmg_id) ||
          filteredProjectIds.includes(item.secondary_hmg_id) ||
          filteredProjectIds.includes(item.third_hmg_id) ||
          filteredProjectIds.includes(item.fourth_hmg_id))
      ) {
        return true;
      } else {
        return false;
      }
    });

    form.resetFields(["hotel"]);
    setHmgId(hmgId);
    setFilteredHotels(filteredHotels);
    setFilteredProjects(filteredProjects);
  };

  const hotelChange = (hotelId) => {
    setHotelId(hotelId);
  };

  useEffect(() => {
    let validHotel = hotelData.filter((item) => {
      return item._id === hotelId;
    })[0];

    let hotelProject = filteredProjects.filter((item) => {
      return (
        item._id === validHotel.primary_hmg_id ||
        item._id === validHotel.secondary_hmg_id ||
        item._id === validHotel.third_hmg_id ||
        item._id === validHotel.fourth_hmg_id
      );
    })[0];

    if (hotelProject) {
      let tempValidEnvelope = validHotel ? validHotel.secondary_envelopes : [];
      tempValidEnvelope = tempValidEnvelope.filter((item) => {
        return item.proj_id === hotelProject._id;
      })[0];

      console.log(tempValidEnvelope);
      setValidEnvelope(tempValidEnvelope);
    }
  }, [hotelId]);

  const disabledDate = (current) => {
    let validDate = true;
    if (current.isBefore(new Date()) && validEnvelope) {
      if (validEnvelope.envelope_business_date === "lastday") {
        let endOfmonth = moment(current).endOf("month").date();
        validDate = current.date() !== endOfmonth;
      } else if (
        current.month() === 1 &&
        parseInt(validEnvelope.envelope_business_date) > 28
      ) {
        // month Feb and day > 29
        validDate = current.date() !== 28;
      } else {
        //all months including feb but not feb 29
        validDate =
          current.date() !== parseInt(validEnvelope.envelope_business_date);
      }
    }

    return validDate;
  };

  return (
    <Form
      labelCol={{ span: 5 }}
      wrapperCol={{ span: 12 }}
      form={form}
      name="manualTriggerForm"
      onFinish={onFinish}
      // onValuesChange={onValuesChange}
    >
      {/* HMG */}
      <Form.Item
        name="hmg"
        label="Hotel Management Group"
        rules={[
          {
            required: true,
            message: "Hotel Management Group is required",
          },
        ]}
      >
        <Select
          showSearch
          placeholder="Enter Hotel Management Group"
          onChange={hmgChange}
          optionFilterProp="children"
          notFoundContent={null}
        >
          {hmgData
            .sort((a, b) => {
              return a.hmg_name.localeCompare(b.hmg_name);
            })
            .map((d) => {
              return (
                <Option key={"HMG_2" + d._id} value={d._id}>
                  {d.hmg_name}
                </Option>
              );
            })}
        </Select>
      </Form.Item>

      {/* HOTEL */}
      <Form.Item
        name="hotel"
        label="Hotel Name"
        rules={[
          {
            required: true,
            message: "Hotel is required",
          },
        ]}
      >
        {hmgId ? (
          <Select
            showSearch
            placeholder="Enter Hotel"
            optionFilterProp="children"
            onChange={hotelChange}
            notFoundContent={null}
          >
            {filteredHotels
              .sort((a, b) => {
                return a.hotel_code.localeCompare(b.hotel_code);
              })
              .map((d) => {
                return (
                  <Option key={"H2" + d._id} value={d._id}>
                    {d.hotel_code} - {d.hotel_name}
                  </Option>
                );
              })}
          </Select>
        ) : (
          <Input disabled={true} />
        )}
      </Form.Item>

      {/* Business DATE */}
      <Form.Item
        name="businessDate"
        label="Business Date"
        rules={[
          {
            required: true,
            message: "Business Date required",
          },
        ]}
      >
        <DatePicker
          disabled={!hotelId}
          disabledDate={disabledDate}
          format="MM-DD-YYYY"
          placeholder="MM-DD-YYYY"
        />
      </Form.Item>

      {/* SIGNATURE GO LIVE DATE */}
      <Form.Item
        name="skipMandatory"
        label=" "
        colon={false}
        valuePropName="checked"
      >
        <Checkbox>Skip mandatory report check</Checkbox>
      </Form.Item>

      {/* CONTROLS */}
      <Form.Item>
        <Row justify="center">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Row>
      </Form.Item>
    </Form>
  );
};

export default ManualTriggerForm;
